import React from 'react';
import * as Bixby from '$/core';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import CompanyLoanDetails from './CompanyLoanDetails';
import Loading from '$/components/loading/Loading';

interface ICompanyLoanAndRatingsProps {
  draftCompany?: Bixby.Models.DraftCompany;
  currentCompany?: Bixby.Models.AdminCompany;
  draftIsLoading: boolean;
  companyIsLoading: boolean;
  isEditing: boolean;
}

const CompanyLoanAndRatings: React.FC<ICompanyLoanAndRatingsProps> = props => {
  const { draftCompany, currentCompany, companyIsLoading, draftIsLoading, isEditing } = props;
  if (companyIsLoading && draftIsLoading) {
    return <Loading pageLevel />;
  } else if (
    (isEditing && draftCompany && !Bixby.Utils.isNullOrEmpty(draftCompany)) ||
    (!isEditing && currentCompany && !Bixby.Utils.isNullOrEmpty(currentCompany))
  ) {
    return (
      <React.Fragment>
        <CompanyLoanDetails />
      </React.Fragment>
    );
  } else {
    return null;
  }
};

const mapStateToProps = (state: AppState) => {
  return {
    draftCompany: state.draftState.draftCompany,
    currentCompany: state.companyState.currentCompany,
    draftIsLoading: state.draftState.isLoading,
    companyIsLoading: state.companyState.isLoading,
    isEditing: state.draftState.isEditing,
  };
};

export default connect(mapStateToProps)(CompanyLoanAndRatings);
